module.exports = __webpack_public_path__ + "img/mc.e499a58a.svg";